import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31ac3396"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reset-password" }
const _hoisted_2 = { class: "box-menu" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__transcription" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "form__title" }, "Redefinição de senha"),
  /*#__PURE__*/_createElementVNode("p", { class: "form__description" }, " Detectamos que este é seu primeiro acesso. Crie uma nova senha. ")
], -1))
const _hoisted_4 = { class: "form__containers" }
const _hoisted_5 = { class: "container__terms" }
const _hoisted_6 = {
  class: "label__terms",
  for: "terms"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Aceito os ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Termos de Uso e Política de Privacidade")
const _hoisted_9 = { class: "form__containers__box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "form__containers__input",
  class: "form__containers__label"
}, "Mostrar senha", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  form: "new-password",
  class: "form__input form__input--submit",
  type: "submit",
  value: "Salvar e entrar"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputPassword = _resolveComponent("InputPassword")!
  const _component_ModernInput = _resolveComponent("ModernInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn--reset-pass-exit",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
      }),
      _createElementVNode("form", {
        id: "new-password",
        class: "form",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.changePassword(_ctx.password, _ctx.confirmation)), ["prevent"]))
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              id: "terms",
              type: "checkbox",
              class: "input__terms",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.term) = $event))
            }, null, 512), [
              [_vModelCheckbox, _ctx.term]
            ]),
            _createElementVNode("label", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_router_link, {
                to: { name: 'terms' },
                target: "_blank"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_InputPassword, {
            id: "input-new-password",
            form: "new-password",
            required: "",
            label: "Senha",
            typeInput: _ctx.currentType,
            "model-value": _ctx.password,
            "onUpdate:model-value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event))
          }, null, 8, ["typeInput", "model-value"]),
          _createVNode(_component_ModernInput, {
            form: "new-password",
            type: _ctx.currentType,
            id: "confirmation-password",
            label: "Confirmar senha",
            "user-data": _ctx.confirmation,
            "onUpdate:user-data": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmation) = $event)),
            required: ""
          }, null, 8, ["type", "user-data"]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("input", {
              id: "form__containers__input",
              type: "checkbox",
              form: "new-password",
              class: "form__containers__input",
              onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.togglePasswordVisibility($event)))
            }, null, 32),
            _hoisted_10
          ])
        ]),
        _hoisted_11
      ], 32)
    ])
  ]))
}